export const style = {
  mainWrapper: {
    position: "relative",
    display: "flex",
    flexDirection: "column",

    width: "100%",
  },
  button1: {
    fontWeight: "bold",
    color: "text.primary",
    fontSize: "14px",
    marginRight: "16px",
    textTransform:'uppercase'
  },
};

export const dStyle = {
  motion: {
    width: "100%",
  },
  box1: {
    top: "100%", // Posiziona il dropdown subito sotto il bottone
    left: 0,
    backgroundColor: "white",
    padding: "16px",
    zIndex: 1,
    width: "100%",
  },
  box2: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-end",
    justifyContent: "flex-end",
    columnGap: "16px",
    rowGap: "16px",
    width: "100%",
    flexWrap: "wrap",
  },
  filterBox: {
    minWidth: "190px",
  },
  filterLabel: {
    fontSize: "14px",
    fontWeight: "bold",
    color: "primary.main",
  },
  filterSelect: { maxHeight: "30px", fontWeight: "bold", maxWidth: "190px", fontSize:'12px' , paddingTop:'3px'},
  filterSelect2: { maxHeight: "30px", fontWeight: "bold", maxWidth: "190px", fontSize:'12px' , },
  filterDrBox: { minWidth: "200px" },
};

export const mStyle = {
  dialogSlotProps: {
    backgroundColor: "rgba(0, 0, 0, 0.2)",
  },
  box1: {
    borderWidth: "2px",
    borderColor: "primary.main",
    borderRadius: "4px",
  },
  box2: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "8px",
  },
  dialogTitle: {
    padding: 0,
    margin: 0,
    marginLeft: "8px",
    fontSize: "14px",
    fontWeight: "bold",
  },
  iconButton: { fontSize: "18px", color: "text.primary" },
  dialogContent: {
    padding: 0,
    margin: 0,
  },
  dialogAction: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  box3: {
    top: "auto", // Posiziona il dropdown subito sotto il bottone
    padding: "16px",
    zIndex: 1,
    width: "100%",
  },
  box4: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    columnGap: "16px",
    rowGap: "16px",
    width: "100%",
  },

  filterLabel: {
    fontSize: "14px",
    fontWeight: "bold",
    color: "primary.main",
  },
  filterSelect: {
    maxHeight: "40px",
    fontWeight: "bold",
  },
};

export const customInputStyle = {
  mainWrapper: {
    width: "100%",
  },
  calendarIcon: {
    fontSize: "14px",
  },
  button: {
    color: "text.primary",
    borderColor: "#bfbfbf",
    height: "30px",
    fontWeight: "bold",
    textTransform: "none",
    fontSize:'12px'
  },
};
